import { render, staticRenderFns } from "./ManageCarousel.vue?vue&type=template&id=04306740&scoped=true&"
import script from "./ManageCarousel.vue?vue&type=script&lang=js&"
export * from "./ManageCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ManageCarousel.vue?vue&type=style&index=0&id=04306740&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04306740",
  null
  
)

export default component.exports